module.exports = __webpack_public_path__ + "img/time-management-1-dark.2bd43809.svg";